import { BASE_URL } from '@/constants/configs';

export const fontFamily = {
  primary: 'Vista Sans OT, Poppins, sans-serif',
};

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

const getFontFaces = () => {
  const fontBasePath = `${BASE_URL}assets/fonts/cayman/vista-sans`;

  return `
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-Light.woff2') format('woff2');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-LightItalic.woff2') format('woff2');
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-Reg.woff2') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-RegItalic.woff2') format('woff2');
  font-weight: 400;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-Medium.woff2') format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-MediumItalic.woff2') format('woff2');
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-Medium.woff2') format('woff2');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-MediumItalic.woff2') format('woff2');
  font-weight: 600;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-Bold.woff2') format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Vista Sans OT';
  src: url('${fontBasePath}/VistaSansOT-BoldItalic.woff2') format('woff2');
  font-weight: 700;
  font-style: italic;
  font-display: swap;
}
`;
};

let fontsInjected = false;

export const injectCaymanFonts = () => {
  if (fontsInjected || typeof document === 'undefined') {
    return;
  }

  const style = document.createElement('style');
  style.id = 'cayman-fonts';
  style.textContent = getFontFaces();
  document.head.appendChild(style);
  fontsInjected = true;
};
